import React, { useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FinancedOffersListComponent from "./FinancedOffersListComponent";
import { getFinancedOffers, getOfferPartners } from "../selectors";
import { loadFinancedOffers, loadFolderOfferPartners, blockFacilitySublimitAmountManually } from "../actionCreators";
import { getClientData } from "../../info/selectors";
import { env } from "utils/env";

const FinancedOffersContainer = ({
  documentId,
  siteId,
  actions,
  financedOffers,
  offerPartners,
  userInfo,
  history,
  clientData,
  isLoaded,
  displayAssociatedPartners,
  masterPartnerApp
}) => {
  const masterPartnerPath = env.REACT_APP_LSNG_MASTERPARTNER_URL;

  useEffect(() => {
    if (!documentId) return;
    actions.loadFinancedOffers(documentId, siteId);
    if (displayAssociatedPartners) actions.loadFolderOfferPartners(documentId, siteId);
  }, [documentId, siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!documentId) return;
    actions.loadFinancedOffers(documentId, siteId);
  }, [documentId, financedOffers]); // eslint-disable-line react-hooks/exhaustive-deps

  const openMasterPartner = masterPartnerId => e => {
    e.stopPropagation();
    if (!masterPartnerApp) return;
    window.open(`${masterPartnerPath}/partners/${masterPartnerId}`, "_blank");
  };

  const openFinancedOffer = (offerId, offerSiteId) => e => {
    e.stopPropagation();
    window.open(`/offers/${offerId}/${offerSiteId}`, "_blank");
  };

  const openFolder = (folderId, folderSiteId) => e => {
    e.stopPropagation();
    window.open(`/folders/${folderId}/${folderSiteId}/generalData`, "_blank");
  };

  const onAddFinancedOffers = () => () => {
    history.push(`/folders/${documentId}/${siteId}/clientoffers/${clientData.clientId}`);
  };

  const onRemoveFinancedOffers = () => () => {
    history.push(`/folders/${documentId}/${siteId}/removefinancedoffers/${clientData.clientId}`);
  };

  const openOfferClientQuestionnaire = (offerId, offerSiteId, partnerId, partnerRole) => e => {
    e.stopPropagation();
    const newWindow =
      partnerRole === "Client"
        ? window.open(`/offers/${offerId}/${offerSiteId}/client`, "_blank")
        : window.open(`/offers/${offerId}/${offerSiteId}/partner/${partnerId}`, "_blank");
    const openQuestionnaire = true;

    newWindow.addEventListener("load", () => {
      setTimeout(() => {
        newWindow.postMessage(openQuestionnaire, window.location.origin);
      }, 3000);
    });
  };

  const onBlockFacilitySublimitAmountManually = useCallback((documentId, siteId, documentTypeCode) => {
    actions.blockFacilitySublimitAmountManually(documentId, siteId, documentTypeCode);
  }, [actions])

  return (
    <>
      {isLoaded && (
        <FinancedOffersListComponent
          userInfo={userInfo}
          isRemoveOffersMode={false}
          isSelectionMode={false}
          financedOffers={financedOffers}
          offerPartners={offerPartners}
          openOfferClientQuestionnaire={openOfferClientQuestionnaire}
          onAddFinancedOffers={onAddFinancedOffers}
          onRemoveFinancedOffers={onRemoveFinancedOffers}
          openFinancedOffer={openFinancedOffer}
          openMasterPartner={openMasterPartner}
          masterPartnerApp={masterPartnerApp}
          openFolder={openFolder}
          onBlockFacilitySublimitAmountManually={onBlockFacilitySublimitAmountManually}
          displayAssociatedPartners={displayAssociatedPartners}
          handleClientOfferSelection={function () {}}
          selectAllClientOffers={function () {}}
          onAddClientOffersOnFolder={function () {}}
          updateFinancedOffersOnFolder={function () {}}
          isLoaded={isLoaded}
        />
      )}
    </>
  );
};

FinancedOffersContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  financedOffers: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  clientData: PropTypes.object.isRequired,
  isLoaded: PropTypes.bool,
  offerPartners: PropTypes.array.isRequired,
  masterPartnerApp: PropTypes.bool,
  userInfo: PropTypes.object.isRequired,
  displayAssociatedPartners: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
  return {
    clientData: getClientData(state),
    financedOffers: getFinancedOffers(state, ownProps.documentId, ownProps.siteId),
    offerPartners: getOfferPartners(state),
    isLoaded: state.currentFolder.financedOffers.isLoaded,
    offerPartnersLoaded: state.currentFolder.offerPartners.isLoaded,
    userInfo: state.userInfo
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadFinancedOffers, loadFolderOfferPartners, blockFacilitySublimitAmountManually }, dispatch),
    dispatch
  };
}

export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps))(FinancedOffersContainer));
